export default __webpack_public_path__ + "static/media/spice-level.85ef161a.svg";